module.exports = {"340705005":"东郊","340705100":"西湖镇","340705198":"铜官区虚镇","340705400":"铜陵市经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340705.json
// module id = 998
// module chunks = 0